import React from 'react';  
import './App.css';
import Counter from './components/Counter'

function App() {
  return (
    <div className="App flex items-center justify-center h-screen">
      <Counter />
    </div>
  );
}

export default App;
